module.exports = __webpack_public_path__ + "0fd6090ed341128dc9be64c9ef1a93d7.png";


//////////////////
// WEBPACK FOOTER
// ./app/pages/HomePage2/Features/mix-match.png
// module id = 857
// module chunks = 1